// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/lista
 *
 * List of orders for the current franchise filter, newest first.
 */
import type { Orders_OrderListRow } from './Orders_OrderListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ListaResponseDados = Orders_OrderListRow[];

export type Orders_ListaResponse = ApiResponse<Orders_ListaResponseDados>;

registerResponseContract('Orders_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_order_id:                   { type: 'number',  required: true },
      so_order_client_id:            { type: 'number',  required: false },
      so_order_franchise_id:         { type: 'number',  required: true },
      so_order_location_id:          { type: 'number',  required: false },
      so_order_origin:               { type: 'string',  required: true },
      so_order_status:               { type: 'string',  required: true },
      so_order_discount_type:        { type: 'string',  required: false },
      so_order_discount_value:       { type: 'number',  required: false },
      so_order_subtotal:             { type: 'number',  required: true },
      so_order_total:                { type: 'number',  required: true },
      so_order_notes:                { type: 'string',  required: false },
      so_order_user_id:              { type: 'string',  required: true },
      so_order_created_at:           { type: 'string',  required: true },
      so_order_cancel_reason:        { type: 'string',  required: false },
      so_order_cancelled_at:         { type: 'string',  required: false },
      so_order_cancelled_by:         { type: 'string',  required: false },
      so_order_legacy_number:        { type: 'number',  required: false },
      so_order_client_name:          { type: 'string',  required: false },
      so_order_total_recebido:       { type: 'number',  required: true },
      so_order_financial_status:     { type: 'string',  required: true },
      so_order_items_count:          { type: 'number',  required: true },
      so_order_expected_delivery_at: { type: 'string',  required: false },
      items_json:                    { type: 'string',  required: false },
      franquia:                      { type: 'string',  required: false },
    },
  },
})
